<template>
<div class="component-index default-content-container"
v-bind:class="{ landscape: isLandscape, 'portrait': isPortrait, mobile : isMobile  }"
>
    <h1 class="page-title">Henning Maier-Jantzen <em>{{pageTitle}}</em></h1>  

    <div class="index-container margin-top-container" v-bind:style="{ marginRight : windowMargin + 'px' }">

        <div class="index-project" v-for="(project, index) in filteredProjects" v-if="project.type != 'homepage'" :key="project.id" 
            v-bind:id="'index-' + project.id"
            >

            <div class="index-project-info">
                <span class="index-project-title">{{project.title[lang]}}</span> 
                <span class="index-project-category">{{getCategoryBySlug( project.category[0] )}}</span>
                <span class="index-project-client">{{project.client}}</span>
            </div>

            <div class="index-project-track-wrapper">
                <div class="track-nav track-nav-left" v-on:click="trackMoveLeft(project.id)" >
                <img src='/static/images/icons/HMJ-Cursor-Scroll-Left.svg' alt='left arrow'>
                </div>
                <div class="track-nav track-nav-right" v-on:click="trackMoveRight(project.id)">
                    <img src='/static/images/icons/HMJ-Cursor-Scroll-Right.svg' alt='left arrow'>
                </div>

                <div class="index-project-slide-track">
                    <div v-for="(image, imageIndex) in project.images" class="index-project-slide" :key="image.file">
                        <router-link :to="{name : 'project-slide', params : { slug : project.id, index : imageIndex }}">
                        <div v-bind:style="{height: 133 + 'px', width: 133 * (image.view.width / image.view.height) + 'px' }"
                            style="background: #E5E5E5"
                            >
                            <img class="index-image"
                               v-bind:id="'index-' + project.id + '--' + imageIndex"
                                v-bind:style="{height: 133 + 'px', width: 133 * (image.view.width / image.view.height) + 'px' }"
                                src="/static/images/placeholder.gif" v-bind:data-src="'/static/assets2/small/' + project.directory + '/' + image.file">
                            </div>
                        </router-link>
                        <div class="download hide-for-small-only hide-for-medium-only" @click="download(image)">
                            <a>
                                <img src="/static/images/icons/HMJ-Download.svg">
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>


<script>
import store from './store/store';
export default {
    name : 'index',
    
    computed : {

        lang()                      { return store.state.language },
        textVariables()             { return store.state.textVariables; },
        sidebarStatus()             { return store.state.sidebar.status; },
        windowHeight()              { return store.state.layout.height; },
        windowWidth()               { return store.state.layout.width; },
        domElements()               { return store.state.domElements; },
        projects()                  { return store.state.projects},
        projectsCurrentIndex()      { return store.state.projectsCurrentIndex; },
        projectsCurrentId()         { return store.state.projectsCurrentId; },
        windowRatio()               { return store.getters.getLayoutRatio },
        windowMargin()              { return store.getters.getWindowMargin },
        windowHeight()              { return store.state.layout.height; },
        windowWidth()               { return store.state.layout.width; },
        categoryFilter()            { return store.state.categoryFilter },
        layout()                    { return store.state.layout },
        isMobile()                  { if (store.state.layout.type != 'large') { return true; } return false; },
        isLandscape()               { if( this.isMobile && this.layout.orientation == 'landscape' ) { return true } return false; },
        isPortrait()                { if( this.isMobile && this.layout.orientation == 'portrait' ) { return true } return false; },
        pageTitle()                 { 
            if(this.$route.name != 'index-client' && this.categoryFilter) {

                var cat = false;
                for(var i = 0; i < store.state.categories.length; i++) {
                    if(store.state.categories[i].slug == this.categoryFilter) {
                        cat = store.state.categories[i];
                    }
                }

                return cat.title[this.lang];

                
            } 

            if(this.$route.name == 'index-client') {

                return this.filteredProjects[0].client;
            }

                return this.textVariables.allProjects[this.lang];
        },

        filteredProjects()          { 

            $('.track-nav').hide();
            var filtered = [];

            if(this.$route.name == 'index-category' || this.$route.name == 'index') {
                if(this.categoryFilter) {
                    for(var i = 0; i < this.projects.length; i++) {
                        if(this.projects[i].category[0] == this.categoryFilter) {

                            filtered.push(this.projects[i]);
                        }
                    }
                } else {
                    filtered = this.projects;
                }
            }

            if(this.$route.name == 'index-client') {

                    for(var i = 0; i < this.projects.length; i++) {
                        if(this.projects[i].clientSlug == this.$route.params.clientSlug) {

                            filtered.push(this.projects[i]);
                        }
                    }

            }

            return filtered;

        },
    },

    data () {
        return {

        }
    },


    created () {
        this.setFilter(store.state.route.params.category);

            this.$nextTick(function() {
                
                $('.track-nav').hide();
                this.unveil();

                $('body').velocity({ opacity: 1 }, { duration : 1200, complete : this.checkTrackNavigation.bind(this) })
            })
        if(this.sidebarStatus < 2 && this.layout.type == 'large') {

            store.commit('setSidebar', 1);

        }

        if(this.layout.type != 'large') {
            store.commit('setSidebar', 0);
        }
    },

    watch : {


        // check track width and track navigation arrows
        sidebarStatus : function(val, oldVal) {

            $('.track-nav').hide();
            console.log('Check track width after sidebar change');
           $('body').velocity({ opacity : 1 }, {duration: 700,  complete : this.checkTrackNavigation.bind(this) });
           // this.checkTrackNavigation(); 
        },

        // compare track with of projects with window width
        windowWidth : function(val, oldVal) {
            console.log('Track parent changed ' + oldVal + 'px to ' + val);

            // loop through projects
            this.checkTrackNavigation();

        },

        // watch route 
        $route : function(val, oldVal) {

            $('.track-nav').hide();
        if(this.sidebarStatus < 2 && this.layout.type == 'large') {

            store.commit('setSidebar', 1);

        }

        if(this.layout.type != 'large') {
            store.commit('setSidebar', 0);
        }

            this.setFilter(store.state.route.params.category);
            console.log('unveil ' + Date.now());
            
            this.$nextTick(function() {
                
                this.unveil();
                this.checkTrackNavigation();
            })

        }

    },

    methods : {


        // loop through projects and compare track width with viewport width
        // display arrows, if needed
        checkTrackNavigation : function() {

            $('.track-nav').hide();
            // hide all track navigation elements 
            console.log('Check Track Navigation for all projects ' + Date.now());

            // we only want to show the arrays on large displays
            if(this.layout.type != 'large') {
                return false;
            }

            for(var i = 0; i < this.filteredProjects.length; i++) {

                var wrapper = $('#index-' +  this.filteredProjects[i].id);
                var track = $('#index-' + this.filteredProjects[i].id + ' .index-project-slide-track');
                var images = this.filteredProjects[i].images;

                var width = 0;

                for(var w = 0; w < images.length; w++) {
                    width += 133 * ( images[w].view.width / images[w].view.height ) + 10;
                }

                if(width > Number( wrapper.width() )) {

                    $('#index-' + this.filteredProjects[i]. id + ' .track-nav-right').show();
                    console.log('check index track for #' + this.filteredProjects[i].id + ' -- ' + wrapper.width() + ' -- ' + width  )
                }

            };

            

            // loop through projects and make visible, where needed
        },

        checkLeftTrackNav : function(projectId) {

            var scrollLeft = $('#index-' + projectId + ' .index-project-slide-track').scrollLeft();

            // show left arrow, if we are at the current position
            var scrollLeft = $('#index-' + projectId + ' .index-project-slide-track').scrollLeft();
            var trackWidth = $('#index-' + projectId + ' .index-project-slide-track').width();

            if(scrollLeft > 0) {
        
                    // $('#index-' + projectId + ' .track-nav-left').show();
                     $('#index-' + projectId + ' .track-nav-left').show();
            } else {

                    $('#index-' + projectId + ' .track-nav-left').hide();
            }
        },


        trackMoveRight : function(projectId) {
            
            this.trackMove(projectId, 1);
        },

        trackMoveLeft : function(projectId) {

            this.trackMove(projectId, -1);
        },

        trackMove : function(projectId, direction) {
            
            // get current Scroll Position
            var scroll = $('#index-' + projectId + ' .index-project-slide-track').scrollLeft();
            var trackWidth = $('#index-' + projectId + ' .index-project-slide-track').width();
            var newScroll = Number(scroll) + ( direction * this.layout.viewportWidth );
            var incrementer = 0.01;

            console.log('Move track from ' + scroll + 'total width is' + trackWidth);
            // $('#index-' + projectId + ' .index-project-slide-track').scrollLeft(newScroll);

            // loop and animate
            var that = this;
            function animateTrack() {
                incrementer += 0.0035;
                scroll = ( Number( scroll ) + (2 * direction) ) ;

                if(direction > 0) {
                    scroll += (1/incrementer);
                    if(scroll <= newScroll && scroll <= trackWidth ) {
                        requestAnimationFrame(animateTrack);
                        $('#index-' + projectId + ' .index-project-slide-track').scrollLeft(scroll);
                    }


                } else {

                    scroll -= (1/incrementer);
                    if(scroll >= newScroll) {
                        requestAnimationFrame(animateTrack);
                        $('#index-' + projectId + ' .index-project-slide-track').scrollLeft(scroll);
                    }
                }

                that.checkLeftTrackNav(projectId);

            };

            animateTrack();

        },

            

        setFilter : function(filter) {
            if(filter) {
                
                store.commit('setCategoryFilter', filter);
            } else {

                store.commit('setCategoryFilter', false);
            }
        },

        download : function(image) {
            
            store.dispatch('downloadImage', image);
        },

        getCategoryBySlug : function(slug) {
             
                var cat = false;
                for(var i = 0; i < store.state.categories.length; i++) {
                    if(store.state.categories[i].slug == slug) {
                        cat = store.state.categories[i];
                    }
                }

                return cat.title[this.lang];
        },

        unveil : function() {

            $(".index-project-slide .index-image")
                .unbind()
                .css({opacity : 0})
                .attr('src', '/static/images/placeholder.gif')

            console.log("Unveil all images" );

            for(var i = 0; i < this.filteredProjects.length; i++) {

                for (var p = 0; p < this.filteredProjects[i].images.length; p++) {

                    var id = 'index-' + this.filteredProjects[i].id + '--' + p;
                        var src = '/static/assets2/small/' + this.filteredProjects[i].directory + '/' + this.filteredProjects[i].images[p].file;
                        console.log(src);

                    $("#" + id)
                        .unbind()
                        .attr('src', '/static/images/placeholder.gif')
                        .on('load', function() {  

                            var delay = Math.floor((Math.random() * 15) + 1) * 40;
                            $(this).velocity({ opacity : 1 }, { easing: "easeInOutQuad", duration: 600, delay : delay });
                        })
                        .attr('src', src)
                        ;



                }

            }
                

        }

        
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?631ba0ee